import { axiosClient, getToken } from 'Config/axiosConfig';

//Definicion Controller
export const getRegimenes = async () => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.get(`/regimenFiscal`, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
export const getEntidades = async () => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.get(`/entidades`, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
export const getEntidadesByPais = async (pais: string) => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.get(`/entidades?c_pais=${pais}`, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
export const getEmpresaById = async (empresaId: number) => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.get(`/empresas/${empresaId}`, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
// Simple in-memory cache to avoid repeated requests for the same company info
const empresaInfoCache = new Map<number, Promise<any>>();

export const getEmpresaInfoById = async (empresaId: number) => {
  const token = localStorage.getItem('pxc-tkn') || '';
  if (!empresaId && empresaId !== 0) {
    return Promise.reject(new Error('empresaId inválido'));
  }
  const cached = empresaInfoCache.get(empresaId);
  if (cached) return cached;

  const fetchWithToken = () => axiosClient.get(`/empresas/${empresaId}`, { headers: { Authorization: token } });
  const fetchPublic = () => axiosClient.get(`/empresaInfo/${empresaId}`);

  const req = token ? fetchWithToken() : fetchPublic();
  empresaInfoCache.set(empresaId, req);
  try {
    const resp = await req;
    return resp;
  } catch (e: any) {
    empresaInfoCache.delete(empresaId);
    // Fallback to public endpoint on 401/403
    const status = e?.response?.status;
    if (token && (status === 401 || status === 403)) {
      const retry = fetchPublic();
      empresaInfoCache.set(empresaId, retry);
      return await retry;
    }
    throw e;
  }
};
export const getUserById = async (userId: number) => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.get(`/usuarios/${userId}`, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
/** Verifica contraseña actual del usuario autenticándose contra /auth */
export const verifyCurrentPassword = async (email: string, currentPassword: string) => {
    return await axiosClient.post(`/auth`, { email, password: currentPassword });
};
export const patchUsuarioData = async (data: {}, userId: number) => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.patch(`/usuarios/${userId}`, data, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
export const patchEmpresaData = async (data: {}, empresaId: number) => {
    console.log('ejecuntando peticion...');
    const token = localStorage.getItem('pxc-tkn') || '';
    return await axiosClient.patch(`/empresas/${empresaId}`, data, {
        headers: {
            Authorization: `${token}`,
        },
    });
};
export const patchImagenEmpresa = async (file: any, userId: number) => {
	console.log('ejecuntando peticion...', file);
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.post(`/empresas/imagen/${userId}`, file, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
export const getEmpresaLogoByLogo = async (logoName: string) => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.get(`/empresas/imagen/${logoName}`, {
		headers: {
			Authorization: `${token}`,
		},
	});
};
export const postEmpresaLogoByLogo = async (logoFile: any) => {
	const token = localStorage.getItem('pxc-tkn') || '';
	return await axiosClient.post(`empresas/imagen/`, logoFile, {
		headers: {
			Authorization: `${token}`,
		},
	});
};

export const getEmpresas = async () => {
	await getToken();
	return await axiosClient.get(`/empresas`);
};
export const postCambioEmpresas = async (empresa_Id: any) => {
	await getToken();
	return await axiosClient.post(`/cambia_empresa`, empresa_Id);
};
